import { render } from "./Main.vue?vue&type=template&id=0868a2ca&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=0868a2ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0868a2ca"

export default script